import * as THREE from 'three'
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js'
import Card from '../Components/Card.js';

export default class DeckLoader {

    static PLANE_GEOMETRY_MESH = 'PLANE_GEOMETRY_MESH';

    constructor(deck) {
        this.experience = new Experience();
        this.eventBus = this.experience.eventBus;

        this.deck = deck;
        this.cardModel = null;
        this.cards = [];

        this.manager = new THREE.LoadingManager();
        this.manager.onLoad = () => {
            // Note: Card order is important, the loader might add cards in the wrong order, due to network latency.
            this.cards = this.cards.sort((a, b) => a.index - b.index);
            this.eventBus.pushAll('resourcesLoaded');
        }
        // load custom formats
        this.manager.addHandler(/\.gltf$/, new GLTFLoader(this.manager));
        this.manager.addHandler(/\.glsl$/, new THREE.FileLoader(this.manager));
        // loads textures
        const textureLoader = new THREE.TextureLoader(this.manager);
        textureLoader.onLoad = (texture) => {
            texture.flipY = true;
        }
        this.manager.addHandler(/\.(png|jpg|jpeg|webp|svg)$/, textureLoader);


        this.cache = new Map();
        this.loadCards();
    }

    load(path, callback) {
        if (this.cache.has(path))
            return callback(this.cache.get(path));
        const loader = this.manager.getHandler(path);
        loader.load(path, (loadedFile) => {
            this.cache.set(path, loadedFile);
            loader.onLoad && loader.onLoad(loadedFile);
            callback(loadedFile);
        });
    }

    loadCards() {
        const defaultFrontTexture = this.deck.default_front_texture || '/textures/blank_card.png';
        const defaultBackTexture = this.deck.default_back_texture || '/textures/blank_card.png';

        // Note: The deck uses sneak_case here, because this is data coming from the server.
        this.deck.cards.forEach((source, index) => {
            if (this.cards.find(card => card.id === source.id))
                throw new Error(`Card with id ${source.id} already exists!`);

            const frontTexturePath = source?.front?.texture || defaultFrontTexture;
            const backTexturePath = source?.back?.texture || defaultBackTexture;

            this.load(frontTexturePath, (loadedTexture) => {
                const emissiveColor = this.experience?.settings?.emissive_color || this.deck?.emissive_color;
                const card = Card.newFromSourceTexture(source.id, loadedTexture, source.x, source.y, source.z, emissiveColor);
                if (source.face_up) card.faceUp();
                card.setIndex(source.index ?? index);
                this.cards.push(card);

                this.load(backTexturePath, (loadedTexture) => card.setTexture(loadedTexture, Card.BACK_SIDE));

                ['front', 'back'].forEach(side => {
                    const materialSide = side === 'front' ? Card.FRONT_SIDE : Card.BACK_SIDE;

                    ['metalness', 'normal'].forEach(key => {
                        const path = source[side]?.[key];
                        if (!path) return;

                        this.load(path, (loadedTexture) => {
                            switch (key) {
                                case 'metalness':
                                    console.log(`set metalness: ${card.id}[${materialSide}] -> ${path}`);
                                    card.setMetalnessMap(loadedTexture, materialSide);

                                    break;
                                case 'normal':
                                    card.setNormalMap(loadedTexture, materialSide);
                                    break;
                            }
                        });
                    });

                    // Load custom shaders for backside
                    // TODO: enable custom shaders
                    // if (materialSide == Card.BACK_SIDE) {
                    //     if (this.deck.vertex_shader_back && this.deck.fragment_shader_back) {
                    //         this.load(this.deck.vertex_shader_back, (vertShader) => {
                    //             this.load(this.deck.fragment_shader_back, (fragShader) => {
                    //                 Card.sharedUniforms.grayValueSplitPoint.value = Number(this.deck.grayValueSplitPoint ?? 0.0); //cast to number so debug menu adds a slide automatically
                    //                 card.applyCustomShader(vertShader, fragShader, materialSide);
                    //             });
                    //         });
                    //     }
                    // }
                });
            });
        });
    }

}
